import React from 'react'
import '../../styles/Banner.css';

export const Banner = () => {
  return (
    <>
        <div align="banner bgcb animate__animated animate__fadeIn center">
          <iframe
              width="100%"
              height="700"
              autoplay
              /*src="https://www.youtube.com/embed/Ka5TceDi4DA?controls=0&autoplay=1"*/
              src="https://www.youtube.com/embed/Ka5TceDi4DA?autoplay=1&mute=1&enablejsapi=1"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen="1"
              /*style={{display:"block"}}*/
              muted
              loop
          ></iframe>
      </div>
    </>
  )
}




/*export const Banner = () => {
  return (
    <div className='banner bgcb animate__animated animate__fadeIn'>
        {/*<div className='overlay'></div>}
        <video src={videoBg} autoPlay muted loop playsInline/>
        {/*<div className='content'>
            <h1><strong>ACADEMIA UNITY</strong></h1>

            https://youtu.be/Ka5TceDi4DA
  </div>}
    </div>
  )
}*/
